import { render, staticRenderFns } from "./history-back.vue?vue&type=template&id=52f3aead"
import script from "./history-back.vue?vue&type=script&lang=js"
export * from "./history-back.vue?vue&type=script&lang=js"
import style0 from "./history-back.vue?vue&type=style&index=0&id=52f3aead&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports